var map = {
	"./cash-check.svg": "274a",
	"./chart.svg": "6327",
	"./dashboard.svg": "9d77",
	"./finance.svg": "61db",
	"./nfe.svg": "5a72",
	"./phone.svg": "1c44",
	"./sale.svg": "6faf",
	"./stock.svg": "f946",
	"./task.svg": "9f0b",
	"./track.svg": "51be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2d0";